// extracted by mini-css-extract-plugin
export var divider = "_q8-0";
export var systemMessage = "_q8-1";